import { Schema, z } from 'zod';
import { BaseFieldDefinition, BaseFieldDefinitionSchema } from './base';

export namespace EnumFieldDefinition {
  export const TYPE = 'enum';
}
/***
 * Field definition of type enum
 * @typedef EnumFieldDefinition
 * @property - type: type of field
 * @property - options : properties of the field
 */
export type EnumFieldDefinition = BaseFieldDefinition & {
  type: typeof EnumFieldDefinition.TYPE;
  validations: {
    cases: ReadonlyArray<string>;
  };
};

export const EnumFieldDefinitionSchema: Schema<EnumFieldDefinition> =
  BaseFieldDefinitionSchema.and(
    z.object({
      type: z.literal(EnumFieldDefinition.TYPE),
      validations: z.object({
        cases: z.array(z.string())
      })
    })
  );
